import type { ReactNode } from 'react'
import { GhostMark } from './GhostMark'

// Friendly empty/placeholder state — a little brand personality without
// getting in the way. Used for empty lists and not-yet-built sections.
export function EmptyState({
  title,
  body,
  action,
  gaze = { x: 0, y: -6 },
}: {
  title: string
  body?: ReactNode
  action?: ReactNode
  gaze?: { x: number; y: number }
}) {
  return (
    <div
      style={{
        textAlign: 'center',
        padding: 'clamp(2.5rem, 8vw, 5rem) 1.5rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.75rem',
      }}
    >
      <GhostMark size={64} glow gaze={gaze} />
      <h3 style={{ fontSize: '1.15rem', fontWeight: 700, letterSpacing: '-0.02em', marginTop: '0.5rem' }}>
        {title}
      </h3>
      {body && <p style={{ color: 'var(--c-dim)', fontSize: '0.92rem', maxWidth: '42ch' }}>{body}</p>}
      {action && <div style={{ marginTop: '0.5rem' }}>{action}</div>}
    </div>
  )
}
